var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.279,
    height: 13.278,
    viewBox: "0 0 13.279 13.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_copy_2",
    "data-name": "edit copy 2",
    transform: "translate(0 -0.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M12.42.887a2.929,2.929,0,0,0-4.145,0l-7.6,7.6A.38.38,0,0,0,.567,8.7L0,12.873a.379.379,0,0,0,.108.32.387.387,0,0,0,.269.113.307.307,0,0,0,.051,0l2.513-.34a.383.383,0,0,0-.1-.758l-2.015.272.393-2.909L4.282,12.63a.387.387,0,0,0,.269.113.375.375,0,0,0,.269-.113l7.6-7.6a2.927,2.927,0,0,0,0-4.145Zm-4,.934L9.7,3.1,2.763,10.032,1.487,8.756Zm-3.868,10L3.306,10.573l6.935-6.935,1.248,1.248Zm7.467-7.481L8.968,1.286a2.169,2.169,0,0,1,3.053,3.053Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.247a67db5157f7176220c6057fa2dc1b.svg";
export { ForwardRef as ReactComponent };